import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()

export class TemplatesService {
  public baseUrl: string; 
  constructor(private _http: Http) { 
    this.baseUrl = environment.apiUrl;
  }

  	validateIdChannel(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'validateChannel', json, { headers: headers })
			.map(res => res.json());
}

  	getTemplates(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'get-templates', json, { headers: headers })
			.map(res => res.json());
	}


	getTemplateId(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'get-templates-id', json, { headers: headers })
			.map(res => res.json());
	}

    changeTemplateStatus(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'change-templates-status', json, { headers: headers })
			.map(res => res.json());
	}

    changeTemplateType(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'change-templates-type', json, { headers: headers })
			.map(res => res.json());
	}


	getlistTemplate(data: any) : Observable<any>{
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'template?page=' + data.page + '&limit=' + data.limit, { headers: headers })
			.map(res => res.json());
		
	}

	

	getTags(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.get(this.baseUrl + 'tags/' + data.id, { headers: headers })
			.map(res => res.json());
	}

	editTags(data: any) {

		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		delete data.auth_token;
		let json = JSON.stringify(data);

		return this._http.put(this.baseUrl + 'tags/' + data.id, json, { headers: headers })
			.map(res => res.json());
	}

	newTags(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'tags', json, { headers: headers })
			.map(res => res.json());
	}

	deleteTags(data: any) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.delete(this.baseUrl + 'tags/' + data.id, { headers: headers })
			.map(res => res.json());
	}

    filterTemplates(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'filter-templates', json, { headers: headers })
			.map(res => res.json());
	}

    exportAsExcelFile(json: any[], excelFileName: string): void {
    
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        console.log('worksheet',worksheet);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
      }
      
      saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/templates/templates.service.ts